import { createFileRoute } from "@tanstack/react-router";

import { AdminEnterpriseRegisterPage } from "@/features/admin/enterprise-register-page";
import { STATIC_LABELS } from "@/lib/nav-registry";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute(
  "/_authenticated/admin/enterprise-register",
)({
  staticData: { crumb: { label: STATIC_LABELS.adminEnterpriseRegister } },
  component: AdminEnterpriseRegisterPage,
});
